import axios from 'axios';
import _ from 'lodash';

export default {
    state: {
        data: null,
        hashKey: null,
    },
    getters: {
        getSurvey: (state) => state.data,
        getSurveyHashKey: (state) => state.hashKey
    },
    mutations: {
        setSurvey(state, payload) {
            state.data = payload;
        },
        setSurveyHashKey(state, payload) {
            state.hashKey = payload;
        },
    },
    actions: {
        async fetchData({ commit }, payload) {
            try {
                console.log('fetchData payload:', payload);
                const response = await axios.get(`survey/fetch/${payload.id}/${payload.hashKey}`);
                if(!_.isObjectLike( response ))
                    throw new Error('Invalid response format');
                if(response.status){
                    commit('setSurvey', response.data);
                    commit('setSurveyHashKey', payload.hashKey);
                } else {
                    commit('setSurvey', null);
                    commit('setSurveyHashKey', null);
                }
            } catch (error) {
                console.error('Error fetching data:', error);
                commit('setSurvey', null);
            }
        },
    },
}